<template>
  <nav class="app-navbar app-navbar-vue">
    <!-- make this work -->
    <div class="app-navbar-items">
      <span
        class="step"
        :class="step >= 1 ? 'done' : 'notyet'"
        :data-active="step == 0 ? 'true' : 'false'"
      >
        <span class="step-icon"> 1 </span>
        <span class="step-label">{{ $t('rooms') }}</span>
      </span>
      <span
        class="step"
        :class="step >= 2 ? 'done' : 'notyet'"
        :data-active="step == 1 ? 'true' : 'false'"
      >
        <span class="step-icon"> 2 </span>
        <span class="step-label">{{ $t('additionals') }}</span>
      </span>
      <span
        class="step"
        :class="step >= 3 ? 'done' : 'notyet'"
        :data-active="step == 2 ? 'true' : 'false'"
      >
        <span class="step-icon"> 3 </span>
        <span class="step-label">{{ $t('contact') }}</span>
      </span>
      <span
        class="step"
        :class="step >= 4 ? 'done' : 'notyet'"
        :data-active="step == 3 ? 'true' : 'false'"
      >
        <span class="step-icon"> 4 </span>
        <span class="step-label">{{ $t('overview') }}</span>
      </span>
      <span
        class="step"
        :class="step >= 5 ? 'done' : 'notyet'"
        :data-active="step == 4 ? 'true' : 'false'"
      >
        <span class="step-icon"> 5 </span>
        <span class="step-label">{{ $t('pay') }}</span>
      </span>
    </div>
    <div class="progress" style="display: none">
      <div
        v-bind:style="progressbar"
        class="progress-bar"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  </nav>
</template>

<script>
export default {
  props: ['step', 'total'],
  // created: function () {
  //   console.log("step total from parent component:");
  //   console.log(this.step, this.total);
  // },
  computed: {
    progressbar: function () {
      return 'width:' + this.step * 20 + '%'
    }
  }
}
</script>
